const BYTES_IN_MB = 1048576;

const CROP_SIZES = {
  SIZE_100: 'crop_100x100',
  SIZE_200: 'crop_200x200',
  SIZE_500: 'crop_500x500',
};

const ARTIFACT_ID = {
  DOCUMENT_SCAN: 1,
  EMPLOYEE_PHOTO: 2,
  ATTACHMENT: 3,
  CONTRACT_SCAN: 4,
  ONE_STOP_ATTACHMENT: 5,
  NOTE_ATTACHMENT: 6,
  FEEDBACK_ATTACHMENT: 7,
  CRM_ATTACHMENT: 8,
  CANDIDATE_RESUME: 9,
  LEAVE_APPLICATION_SCAN: 10,
  CAREER_DEVELOPMENT_REVIEW_ATTACHMENT: 14,
  EMAIL_ATTACHMENT: 16,
  ARTIFACT_STORAGE_FILE: 17,
  BACKGROUND_CHECK_ATTACHMENT: 18,
  OPPORTUNITY_PRESALE_INPUT_ATTACHMENT: 19,
  OPPORTUNITY_PRESALE_OUTPUT_ATTACHMENT: 20,
};

const FILE_MIME = {
  AAC: {
    ext: 'aac',
    mime: ['audio/aac', 'audio/vnd.dlna.adts'],
  },
  DOC: {
    ext: 'doc',
    mime: ['application/msword'],
  },
  DOCX: {
    ext: 'docx',
    mime: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  },
  RTF: {
    ext: 'rtf',
    mime: ['application/rtf'],
  },
  CSV: {
    ext: 'csv',
    mime: ['text/csv'],
  },
  XLS: {
    ext: 'xls',
    mime: ['application/vnd.ms-excel'],
  },
  XLSX: {
    ext: 'xlsx',
    mime: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  },
  JPG: {
    ext: 'jpg',
    mime: ['image/jpg'],
  },
  JPEG: {
    ext: 'jpeg',
    mime: ['image/jpeg'],
  },
  MP3: {
    ext: 'mp3',
    mime: ['audio/mpeg', 'audio/mp3'], // 'audio/mp3' is used in chromium browsers
  },
  WAV: {
    ext: 'wav',
    mime: ['audio/wav'],
  },
  MP4: {
    ext: 'mp4',
    mime: ['video/mp4'],
  },
  MOV: {
    ext: 'mov',
    mime: ['video/quicktime'],
  },
  PDF: {
    ext: 'pdf',
    mime: ['application/pdf'],
  },
  PNG: {
    ext: 'png',
    mime: ['image/png'],
  },
  GIF: {
    ext: 'gif',
    mime: ['image/gif'],
  },
};

// Extensions, API_FILE_TYPE key
const EXTENSION_TYPE_MAP = {
  // image
  jpg: 'image',
  jpeg: 'image',
  png: 'image',
  gif: 'image',
  webp: 'image',
  bmp: 'image',
  svg: 'image',

  // audio
  mp3: 'mp3',
  aac: 'aac',
  wav: 'wav',

  // video
  mp4: 'mp4',

  // docs
  doc: 'doc',
  docx: 'docx',
  rtf: 'rtf',

  // spreadsheets
  xls: 'xls',
  xlsx: 'xlsx',
  csv: 'csv',

  // pdf
  pdf: 'pdf',
} as const;

export { BYTES_IN_MB, EXTENSION_TYPE_MAP, CROP_SIZES, FILE_MIME, ARTIFACT_ID };
